export enum FormMode {
  EDIT = 1,
  CREATE = 2
}
